
import { motion } from "framer-motion";
import { CheckCheck } from "lucide-react";

const QuizRecommendations = () => {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.9, duration: 0.5 }}
      className="max-w-md bg-gradient-to-b from-white to-[#F8FAFD] p-6 rounded-xl border border-[#E5E9F2] shadow-sm mb-8"
    >
      <p className="text-corporate-primary-75 mb-4 text-left">
        Based on your answers, we can recommend trading strategies that match your knowledge level and preferences.
      </p>
      
      <p className="text-lg font-semibold text-corporate-primary-100 mb-2 text-left">
        What's next?
      </p>
      
      <ul className="text-left space-y-2 mb-4">
        <li className="flex items-start">
          <div className="mt-1 mr-2 bg-corporate-secondary-25 p-1 rounded-full">
            <CheckCheck className="w-4 h-4 text-corporate-secondary-100" />
          </div>
          <span className="text-corporate-neutral-75">Get personalized trading strategy recommendations</span>
        </li>
        <li className="flex items-start">
          <div className="mt-1 mr-2 bg-corporate-secondary-25 p-1 rounded-full">
            <CheckCheck className="w-4 h-4 text-corporate-secondary-100" />
          </div>
          <span className="text-corporate-neutral-75">Access our marketplace of verified trading strategies</span>
        </li>
        <li className="flex items-start">
          <div className="mt-1 mr-2 bg-corporate-secondary-25 p-1 rounded-full">
            <CheckCheck className="w-4 h-4 text-corporate-secondary-100" />
          </div>
          <span className="text-corporate-neutral-75">Start your journey with strategies that match your skills</span>
        </li>
      </ul>
    </motion.div>
  );
};

export default QuizRecommendations;
